module.exports = __webpack_public_path__ + "img/lisa.a3ace344.jpg";